import { render, staticRenderFns } from "./ViberIcon.vue?vue&type=template&id=5f57bfb6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f57bfb6')) {
      api.createRecord('5f57bfb6', component.options)
    } else {
      api.reload('5f57bfb6', component.options)
    }
    module.hot.accept("./ViberIcon.vue?vue&type=template&id=5f57bfb6&", function () {
      api.rerender('5f57bfb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/ViberIcon.vue"
export default component.exports